module.exports = __webpack_public_path__ + "static/media/ios-badge-white.341c9a86.png";